import { render, staticRenderFns } from "./BVNNINComplianceReport.vue?vue&type=template&id=62bce4cb&scoped=true&"
import script from "./BVNNINComplianceReport.vue?vue&type=script&lang=js&"
export * from "./BVNNINComplianceReport.vue?vue&type=script&lang=js&"
import style0 from "./BVNNINComplianceReport.vue?vue&type=style&index=0&id=62bce4cb&lang=scss&scoped=true&"
import style1 from "./BVNNINComplianceReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bce4cb",
  null
  
)

export default component.exports